module.exports = __webpack_public_path__ + "img/person4.109cdc58.jpg";